import Product from '@common/models/Product';
import { fetchProductDetailsRequest, fetchProductReviewsRequest } from '@common/store/productDetails/slice';
import { removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
import React from 'react';
import { Link } from 'react-router-dom';

export interface ProductCardOverlayProps {
  product: Product;
  fetchProductDetailsRequest: typeof fetchProductDetailsRequest;
  fetchProductReviewsRequest: typeof fetchProductReviewsRequest;
  removeToast: typeof removeToast;
  toasts: ToastWithKeyType;
  CloseDetails: boolean;
  SetCloseDetails: () => void;
  computedProductLink: string;
}

const ProductCardOverlay: React.FC<ProductCardOverlayProps> = ({ product, computedProductLink }) => {
  return (
    <div className="overflow-hidden rounded-t-4 cursor-pointer absolute inset-0">
      {!product.inStock ? (
        <div className="bg-black bg-opacity-40 leading-19 h-full w-full absolute text-16">
          <Link to={computedProductLink} className="cursor-pointer">
            <div
              className="text-white font-semibold flex justify-center items-center h-full text-20"
              font-customisation="para-text"
            >
              Out of stock
            </div>
          </Link>
        </div>
      ) : (
        <Link to={computedProductLink} className="cursor-pointer">
          <div className="rounded-20 relative w-full h-full flex justify-center card"></div>
        </Link>
      )}
    </div>
  );
};

export default ProductCardOverlay;
